import React, { useEffect, useState } from 'react';
import { useUser } from '../../../UserContext';

import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';

import { TextField, Button, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme, alpha } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import IconButton from '@mui/material/IconButton';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import Alert from '@mui/material/Alert';
import AddIcon from '@mui/icons-material/Add';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import { saveMenuItemData } from '../../../services/kitchenService';
import { useAuth } from '../../../AuthContext';
import { MENU_ITEM_CATEGORY_LABELS } from '../../../constants';
import { useLocale } from '../../../i18n/LanguageContext';

export default function MenuItemCreatorEditorButton(props) {
  const { auth } = useAuth();
  const { t } = useLocale();
  const [open, setOpen] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [fieldErrors, setFieldErrors] = React.useState({});
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isEditMode = Boolean(props.menuItem);
  var currentMenu = props.menu;
  const getDefaultEmptyMenuItem = () => ({
      id: 0,
      menuId: props.menu?.id,
      name: '', 
      category: '', 
      isActive: false,
      price: 0.0,
      ingredients: '',
      description: '',
      timeToPrepare: 0
    });

  const { user } = useUser();
  const [menuItem, setMenuItem] = useState(isEditMode ? props.menuItem: getDefaultEmptyMenuItem());

  const handleChangeCategory = (event) => {
    const value = event.target.value;
    setMenuItem({...menuItem, category: value});
    if (value) {
      setFieldErrors(prev => ({...prev, category: undefined}));
    } else {
      setFieldErrors(prev => ({...prev, category: t('menuItems.validation.categoryRequired')}));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (value.includes('<') || value.includes('>')) {
      return;
    }
    setMenuItem((prevMenu) => ({ ...prevMenu, [name]: value }));
    const newErrors = {...fieldErrors};
    if (name === 'name') {
      if (value.trim() === '') {
        newErrors.name = t('menuItems.validation.required');
      } else if (value.trim().length < 3) {
        newErrors.name = t('menuItems.validation.minLength');
      } else if (value.length > 100) {
        newErrors.name = t('menuItems.validation.maxLength');
      } else {
        delete newErrors.name;
      }
    } else if (name === 'ingredients') {
      if (value.trim() === '') {
        newErrors.ingredients = t('menuItems.validation.required');
      } else if (value.trim().length < 3) {
        newErrors.ingredients = t('menuItems.validation.ingredientMin');
      } else if (value.length > 500) {
        newErrors.ingredients = t('menuItems.validation.ingredientMax');
      } else {
        delete newErrors.ingredients;
      }
    } else if (name === 'description') {
      if (value.trim() === '') {
        newErrors.description = t('menuItems.validation.required');
      } else if (value.trim().length < 10) {
        newErrors.description = t('menuItems.validation.descriptionMin');
      } else if (value.length > 500) {
        newErrors.description = t('menuItems.validation.descriptionMax');
      } else {
        delete newErrors.description;
      }
    }
    setFieldErrors(newErrors);
  };

  const handlePriceChange = (e) => {
    let inputValue = e.target.value;
    if (inputValue !== '' && !/^\d*\.?\d{0,2}$/.test(inputValue)) {
      return;
    }
    if (inputValue.length > 1 && inputValue[0] === '0' && inputValue[1] !== '.') {
      inputValue = inputValue.replace(/^0+/, '');
    }
    setMenuItem({...menuItem, price: inputValue});
    const numValue = parseFloat(inputValue);
    if (inputValue === '' || isNaN(numValue) || numValue <= 0) {
      setFieldErrors(prev => ({...prev, price: t('menuItems.validation.required')}));
    } else {
      setFieldErrors(prev => ({...prev, price: undefined}));
    }
  };

  const handleTimeToPrepareChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue !== '' && !/^[0-9]+$/.test(inputValue)) {
      return;
    }
    const value = inputValue === '' ? null : parseInt(inputValue, 10);
    if (value && value > 999) {
      return;
    }
    setMenuItem({...menuItem, timeToPrepare: value});
    if (!value || value <= 0) {
      setFieldErrors(prev => ({...prev, timeToPrepare: t('menuItems.validation.required')}));
    } else {
      setFieldErrors(prev => ({...prev, timeToPrepare: undefined}));
    }
  };

  const handleSwitchChange = (e) => {
    setMenuItem({...menuItem, isActive: e.target.checked});
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const newErrors = {...fieldErrors};
    if (name === 'name') {
      if (value.trim() === '') {
        newErrors.name = t('menuItems.validation.required');
      } else if (value.trim().length < 3) {
        newErrors.name = t('menuItems.validation.minLength');
      } else if (value.length > 100) {
        newErrors.name = t('menuItems.validation.maxLength');
      } else {
        delete newErrors.name;
      }
    } else if (name === 'ingredients') {
      if (value.trim() === '') {
        newErrors.ingredients = t('menuItems.validation.required');
      } else if (value.trim().length < 3) {
        newErrors.ingredients = t('menuItems.validation.ingredientMin');
      } else if (value.length > 500) {
        newErrors.ingredients = t('menuItems.validation.ingredientMax');
      } else {
        delete newErrors.ingredients;
      }
    } else if (name === 'description') {
      if (value.trim() === '') {
        newErrors.description = t('menuItems.validation.required');
      } else if (value.trim().length < 10) {
        newErrors.description = t('menuItems.validation.descriptionMin');
      } else if (value.length > 500) {
        newErrors.description = t('menuItems.validation.descriptionMax');
      } else {
        delete newErrors.description;
      }
    }
    setFieldErrors(newErrors);
  };

  const handlePriceBlur = () => {
    const numValue = parseFloat(menuItem.price);
    if (menuItem.price === '' || isNaN(numValue) || numValue <= 0) {
      setFieldErrors(prev => ({...prev, price: t('menuItems.validation.required')}));
    } else {
      const formatted = numValue.toFixed(2);
      setMenuItem({...menuItem, price: formatted});
      setFieldErrors(prev => ({...prev, price: undefined}));
    }
  };

  const handleTimeToPrepareBlur = () => {
    if (!menuItem.timeToPrepare || menuItem.timeToPrepare <= 0) {
      setFieldErrors(prev => ({...prev, timeToPrepare: t('menuItems.validation.required')}));
    }
  };

  const handleCategoryBlur = () => {
    if (!menuItem.category || menuItem.category === '') {
      setFieldErrors(prev => ({...prev, category: t('menuItems.validation.required')}));
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!menuItem.name || menuItem.name.trim() === '') {
      errors.name = t('menuItems.validation.required');
    } else if (menuItem.name.trim().length < 3) {
      errors.name = t('menuItems.validation.minLength');
    } else if (menuItem.name.length > 100) {
      errors.name = t('menuItems.validation.maxLength');
    }
    if (!menuItem.timeToPrepare || menuItem.timeToPrepare <= 0) {
      errors.timeToPrepare = t('menuItems.validation.required');
    }
    if (!menuItem.category || menuItem.category === '') {
      errors.category = t('menuItems.validation.required');
    }
    if (menuItem.price === '' || menuItem.price === null || menuItem.price <= 0) {
      errors.price = t('menuItems.validation.required');
    }
    if (!menuItem.ingredients || menuItem.ingredients.trim() === '') {
      errors.ingredients = t('menuItems.validation.required');
    } else if (menuItem.ingredients.trim().length < 3) {
      errors.ingredients = t('menuItems.validation.ingredientMin');
    } else if (menuItem.ingredients.length > 500) {
      errors.ingredients = t('menuItems.validation.ingredientMax');
    }
    if (!menuItem.description || menuItem.description.trim() === '') {
      errors.description = t('menuItems.validation.required');
    } else if (menuItem.description.trim().length < 10) {
      errors.description = t('menuItems.validation.descriptionMin');
    } else if (menuItem.description.length > 500) {
      errors.description = t('menuItems.validation.descriptionMax');
    }
    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const isFormInvalid = () => {
    return (
      Object.keys(fieldErrors).some(key => fieldErrors[key]) ||
      !menuItem.name?.trim() ||
      !menuItem.timeToPrepare ||
      menuItem.timeToPrepare <= 0 ||
      !menuItem.category ||
      !menuItem.price ||
      menuItem.price <= 0 ||
      !menuItem.ingredients?.trim() ||
      !menuItem.description?.trim()
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    const menuItemData = {
      ...menuItem,
      price: parseFloat(menuItem.price)
    };
    saveMenuItemData(menuItemData, auth).then((savedMenuItem) => {
      if (savedMenuItem) {
        if(props.menuItem) {
          const menuItemIndex = currentMenu.items.map(item => item.id).indexOf(menuItem.id);
          if (menuItemIndex > -1) {
            currentMenu.items[menuItemIndex] = savedMenuItem;
          }
        } else {
          if (!currentMenu.items) {
            currentMenu.items = [];
          }
          currentMenu.items.push(savedMenuItem);
        }
        props.onMenuChange(currentMenu);
        setMenuItem(isEditMode ? savedMenuItem : getDefaultEmptyMenuItem());
        setOpen(false);
      } else {
        setError(true);
      }
    }).catch(() => {
      setError(true);
    });
  };

  const handleClickOpen = () => {
    setError(false);
    setFieldErrors({});
    setMenuItem(isEditMode ? props.menuItem : getDefaultEmptyMenuItem());
    setOpen(true);
  };

  const handleClose = () => {
    setError(false);
    setFieldErrors({});
    setMenuItem(isEditMode ? props.menuItem : getDefaultEmptyMenuItem());
    setOpen(false);
  };

  return (
    <div>
      {isEditMode ? (
        <Tooltip key={'add-edit-menu-item'} title={t('menuItems.editMenuItem')} placement="top-start" value="edit-menu">
          <IconButton 
                data-testid="item-edit-id" 
                color="default" 
                onClick={handleClickOpen}>
                <ModeEditOutlineIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          data-testid="item-edit-id"
          variant="contained"
          disableElevation
          startIcon={<AddIcon />}
          onClick={handleClickOpen}
          sx={(theme) => ({
            mt: 1,
            textTransform: 'none',
            fontWeight: 600,
            px: 2.5,
            py: 1,
            borderRadius: 2,
            color: theme.palette.primary.main,
            backgroundColor: alpha(theme.palette.primary.main, 0.14),
            border: `1px solid ${alpha(theme.palette.primary.main, 0.32)}`,
            '&:hover': {
              backgroundColor: alpha(theme.palette.primary.main, 0.22),
              borderColor: alpha(theme.palette.primary.main, 0.42),
            },
          })}
        >
          {t('menuItems.addNewItem')}
        </Button>
      )}
      
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        { error ? (<Alert severity="error">{t('kitchenDashboard.error')}</Alert>) : ''}
        <DialogTitle id="responsive-dialog-title" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <div>{props.menu ? props.menu.name + ' - ' + t('menuItems.newItem') : t('menuItems.editMenuItem')}</div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 2 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <Typography variant="caption" style={{ fontWeight: menuItem.isActive ? 400 : 600 }}>{t('kitchenMenus.inactive')}</Typography>
                  <Switch 
                    name='isActive'
                    checked={menuItem.isActive} 
                    onChange={handleSwitchChange}
                    value={menuItem.isActive}
                    inputProps={{ 'aria-label': 'Menu item status' }}
                  />
                  <Typography variant="caption" style={{ fontWeight: menuItem.isActive ? 600 : 400 }}>{t('kitchenMenus.active')}</Typography>
                </div>
            </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <form>
            <div>
              <div style={{ display: 'flex', flexDirection: fullScreen ? 'column' : 'row', gap: 16 }}>
                <TextField style={fullScreen ? { width: '100%' } : { flex: 1, flexGrow: 3 }}
                    label={t('menuItems.itemName')}
                    name="name"
                    value={menuItem.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    placeholder={t('menuItems.itemName')}
                    required
                    error={!!fieldErrors.name}
                    helperText={fieldErrors.name}
                    data-testid="menu-item-name-input"
                />
                <TextField style={fullScreen ? { width: '100%' } : { flex: 1, minWidth: 170 }}
                    label={t('menuItems.timeLabel')}
                    name="timeToPrepare"
                    value={menuItem.timeToPrepare}
                    onChange={handleTimeToPrepareChange}
                    onBlur={handleTimeToPrepareBlur}
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    placeholder='0'
                    required
                    error={!!fieldErrors.timeToPrepare}
                    helperText={fieldErrors.timeToPrepare}
                    data-testid="menu-item-time-to-prepare-input"
                    InputProps={{
                      startAdornment: <InputAdornment position="start"><AccessTimeIcon /></InputAdornment>,
                      endAdornment: <InputAdornment position="end">{t('menuItems.min')}</InputAdornment>,
                    }}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', gap: 16 }}>
                <FormControl fullWidth style={{ flex: 1, flexGrow: 2, marginTop: 16 }} required error={!!fieldErrors.category}>
                        <InputLabel id="demo-simple-select-label">{t('menuItems.categoryLabel')}</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="select-category"
                          value={menuItem.category}
                          label={t('menuItems.categoryLabel')}
                          onChange={handleChangeCategory}
                          onBlur={handleCategoryBlur}
                          required
                          error={!!fieldErrors.category}
                          data-testid="menu-item-category-select"
                        >
                          {Object.entries(MENU_ITEM_CATEGORY_LABELS).map(([value, label]) => (
                            <MenuItem key={value} value={value}>{label}</MenuItem>
                          ))}
                        </Select>
                </FormControl>
                <TextField style={{ flex: 1 }}
                    label={t('menuItems.priceLabel')}
                    name="price"
                    value={menuItem.price}
                    onChange={handlePriceChange}
                    onBlur={handlePriceBlur}
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    placeholder='00.00'
                    required
                    error={!!fieldErrors.price}
                    helperText={fieldErrors.price}
                    data-testid="menu-item-price-input"
                    InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    }}
                />
              </div>
              <TextField
                  label={t('menuItems.ingredientsLabel')}
                  name="ingredients"
                  value={menuItem.ingredients}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  placeholder={t('menuItems.itemPlaceholder')}
                  required
                  error={!!fieldErrors.ingredients}
                  helperText={fieldErrors.ingredients}
                  data-testid="menu-item-ingredients-input"
              />
              <TextField 
                  label={t('menuItems.descriptionLabel')}
                  name="description"
                  value={menuItem.description}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  placeholder={t('menuItems.descriptionPlaceholder')}
                  multiline
                  maxRows={5}
                  required
                  error={!!fieldErrors.description}
                  helperText={fieldErrors.description}
                  data-testid="menu-item-description-input"
              />
            </div>
            </form>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} style={{ textTransform: 'none'}}>
            {t('kitchenMenus.cancel')}
          </Button>
          <Button 
            autoFocus 
            style={{ textTransform: 'none'}} 
            variant='contained' 
            onClick={handleSubmit}
            disabled={isFormInvalid()}
          >
            {t('menuItems.save')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}